import BaseDatePickerController from "./base_date_picker_controller"

/**
 * Hero date picker — compact dropdown calendar for the hero booking form.
 *
 * Extends the base date picker with:
 *   - Dropdown toggle (calendar hidden by default, opens on click)
 *   - Trigger button showing selected date count
 *   - Click-outside to close
 *   - Exposes getSelectedDates() for the parent booking-form controller
 */
export default class extends BaseDatePickerController {
  // Only declare NEW targets — base targets (monthLabel, daysGrid, chips, hiddenInputs)
  // are inherited automatically by Stimulus.
  static targets = ["trigger", "dropdown"]

  connect() {
    super.connect()
    this.updateTriggerLabel()
    this._onClickOutside = (event) => {
      if (!this.element.contains(event.target)) {
        this.close()
      }
    }
  }

  disconnect() {
    document.removeEventListener("mousedown", this._onClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    if (this.dropdownTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.dropdownTarget.classList.remove("hidden")
    // Use mousedown so it fires before the click reaches calendar buttons
    document.addEventListener("mousedown", this._onClickOutside)
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    document.removeEventListener("mousedown", this._onClickOutside)
  }

  toggleDate(event) {
    super.toggleDate(event)
    this.updateTriggerLabel()
  }

  removeDate(event) {
    super.removeDate(event)
    this.updateTriggerLabel()
  }

  // Hide chips in hero picker — selected dates shown in trigger label instead
  renderChips() {
    if (this.hasChipsTarget) this.chipsTarget.innerHTML = ""
  }

  updateTriggerLabel() {
    if (!this.hasTriggerTarget) return
    const count = this.selectedDates.size
    if (count === 0) {
      this.triggerTarget.textContent = "Select dates..."
    } else if (count === 1) {
      const dateStr = Array.from(this.selectedDates)[0]
      const date = new Date(dateStr + "T00:00:00")
      this.triggerTarget.textContent = date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    } else {
      this.triggerTarget.textContent = `${count} dates selected`
    }
  }

  getSelectedDates() {
    return Array.from(this.selectedDates).sort()
  }
}
